import ProjectCard from "./ProjectCard";

import "./projects.scss";

export default function Projects() {
  return (
    <div className="projects" id="projects">
      <ol className="roster">
        <ProjectCard
          name="Cartoon Smackdown Ultimate"
          description="A Roblox PvP combat game played over 2 million times, peaking at 700,000 monthly active users."
          link="https://www.roblox.com/games/6694317558/NEW-CODE-Cartoon-SmackDown-Ultimate#!/"
          stat="2,000,000"
          statLabel="plays"
        />
        <ProjectCard
          name="Stock Forecaster"
          description="A stock closing price forecaster built with LSTM neural networks in Python."
          link="https://github.com/kareemxyz/stock_forecaster"
          meta="Python, GitHub"
        />
        <ProjectCard
          name="Command Line REST API"
          description="A REST API that stores command line snippets alongside short descriptions of what each command does."
          link="https://github.com/kareemxyz/command-rest-api"
          meta="GitHub"
        />
      </ol>
    </div>
  );
}
